module.exports = __webpack_public_path__ + "static/media/picture-(122).5b050b33.JPG";